import React from 'react';

import { Stack, Box, Typography, InfoCircleIcon } from '@metarouter-private/mr-mui';

import { FEATURE_FLAGS } from 'app/launch-darkly/featureFlags';
import useFeatureEnabled from 'app/launch-darkly/use-feature-enabled';

export default function PrimaryExplanationMessage() {
  const { secretStorageDevelopmentEnabled } = useFeatureEnabled(FEATURE_FLAGS.secretStorageDevelopment);

  if (!secretStorageDevelopmentEnabled) {
    return null;
  }

  return (
    <Stack display="flex" direction="row" alignItems="start" spacing={1}>
      <Box mt={0.1}>
        <InfoCircleIcon color="disabled" fontSize="small" />
      </Box>

      <Typography variant="body2" component="p" color="text.disabled">
        The{' '}
        <Typography variant="body2" fontWeight="700" component="span">
          Primary Cluster{' '}
        </Typography>
        serves as the default for behaviors like secret storage prior to deployment, executing various testing suite
        actions, and necessary cluster-side validation actions.
      </Typography>
    </Stack>
  );
}
